<div #powerBiContainer class="iframe-container relative w-full h-full">
  <powerbi-report
    [embedConfig]="reportConfig"
    [cssClassName]="classContainer"
    (loaded)="onReportLoad()"
    (rendered)="onReportRender()"
    (error)="onReportError($event)"
  ></powerbi-report>
  <button
    *ngIf="showZoom"
    (click)="openDialog()"
    class="absolute bottom-2 right-2 p-2 bg-white rounded-full shadow-lg z-10"
  >
    <lucide-icon name="fullscreen"></lucide-icon>
  </button>
</div>
